<script lang="ts" setup>
import { ref, defineEmits } from "vue";
const active = ref(true);
const emit = defineEmits(["close"]);

const close = () => {
  active.value = false;
  emit("close", false);
};

// eslint-disable-next-line no-undef
const props = defineProps({
  nobutton: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: "max-w-lg",
  },
});
</script>
<template>
  <div
    class="fixed w-full h-full bg-black/70 inset-0 flex justify-center items-center z-50 popup py-6 px-4"
    :class="{ active: active }"
    v-if="active"
  >
    <div
      :class="`bg-white relative rounded min-h-[95vh] desktop:max-h-none !max-h-[95vh] w-full overflow-hidden shadow-xl ${props.width} relative mx-4 desktop:mx-0 !pt-8`"
    >
      <i
        v-if="props.nobutton"
        @click="close"
        class="fa-solid fa-xmark absolute right-2 top-1 cursor-pointer text-2xl z-50"
      ></i>
      <div
        :class="`desktop:max-h-none  !max-h-[95vh] p-2  w-full overflow-auto shadow-xl ${props.width} relative mx-4 desktop:mx-0 !pt-8`"
      >
        <slot></slot>
        <div v-if="!props.nobutton" class="flex justify-center mb-4">
          <button class="button" @click="close">
            {{ $t("valid_popup.leave") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
